<div class="component-wrapper">
  <div class="{{ lmService?.tab_levels?.length > 0 ? '' : 'p15px' }}">
    <div class="d-flex c-row bg-white">
      <!-- Sidebar -->
      <app-nav-users *ngIf="isHideSideNav"></app-nav-users>
      <!-- Main -->
      <div class="c-col w-100 c-main">
        <div class="body-details pt-0 {{ lmService?.tab_levels?.length > 0 ? '' : 'edit-office-main' }}">
          <!-- Tools -->
          <div class="d-flex align-items-center primary-tabs b-b-tabs" *ngIf="userRole !== 'sales agent'">
            <ul class="nav tools-tab-nav w-100 d-flex align-items-center" role="tablist">
              <li class="nav-item cursor-pointer" role="presentation">
                <a
                  class="active pl-0"
                  id="pills-userinfo{{ tabIndex }}-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#userinfo{{ tabIndex }}"
                  role="tab"
                  aria-controls="userinfo{{ tabIndex }}"
                  aria-selected="true"
                  (click)="tab_name = 'Staff Info'">
                  <img [src]="images?.staff_holiday_icon" alt="contacts" width="14px" class="mr-2" />
                  Staff Info
                </a>
              </li>
              <li class="nav-item cursor-pointer" role="presentation">
                <a
                  class=""
                  id="pills-images{{ tabIndex }}-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#images{{ tabIndex }}"
                  role="tab"
                  aria-controls="images{{ tabIndex }}"
                  aria-selected="false"
                  (click)="tab_name = 'Images'">
                  <img [src]="images?.photo_icon" alt="Images" width="14px" class="mr-2" />Images</a
                >
              </li>
              <li class="nav-item cursor-pointer" role="presentation">
                <a
                  class=""
                  id="pills-associate{{ tabIndex }}-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#associate{{ tabIndex }}"
                  role="tab"
                  aria-controls="associate{{ tabIndex }}"
                  aria-selected="false"
                  (click)="tab_name = 'Associations'">
                  <img [src]="images?.link_two_icon" alt="Associations" width="14px" class="mr-2" />Associations</a
                >
              </li>
              <li class="nav-item cursor-pointer" role="presentation">
                <a
                  class=""
                  id="pills-team-tab{{ tabIndex }}"
                  data-bs-toggle="pill"
                  data-bs-target="#team{{ tabIndex }}"
                  role="tab"
                  aria-controls="team{{ tabIndex }}"
                  aria-selected="false"
                  (click)="tab_name = 'Teams'; getTeams()">
                  <img [src]="images?.team_icon" alt="contacts" width="14px" class="mr-2" />
                  Teams
                </a>
              </li>
              <li
                class="nav-item cursor-pointer"
                role="presentation"
                *ngIf="userRole?.toLowerCase() == 'master admin' || userRole?.toLowerCase() == 'operations manager'">
                <a
                  class=""
                  id="pills-notification{{ tabIndex }}-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#notification{{ tabIndex }}"
                  role="tab"
                  aria-controls="notification{{ tabIndex }}"
                  aria-selected="false"
                  (click)="tab_name = 'Notification'">
                  <img [src]="images?.notification_icon" alt="contacts" width="14px" class="mr-2" />
                  Notifications
                </a>
              </li>
              <li class="nav-item cursor-pointer" role="presentation" *ngFlag="'staff_holidays'">
                <a
                  class=""
                  id="pills-holiday{{ tabIndex }}-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#holiday{{ tabIndex }}"
                  role="tab"
                  aria-controls="holiday{{ tabIndex }}"
                  aria-selected="false"
                  (click)="
                    agentListing();
                    agentContract();
                    agentLead();
                    agentTask();
                    agentProject();
                    getStaff();
                    getInspections();
                    tab_name = 'Staff Holiday'
                  ">
                  <img [src]="images?.staff_holiday_icon" alt="contacts" width="14px" class="mr-2" />
                  Staff Holiday
                </a>
              </li>
              <li class="nav-item cursor-pointer" role="presentation" *ngFlag="'approval'">
                <a
                  class=""
                  id="pills-officeApproval{{ tabIndex }}-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#officeApproval{{ tabIndex }}"
                  role="tab"
                  aria-controls="officeApproval{{ tabIndex }}"
                  aria-selected="false"
                  (click)="tab_name = 'Office Approvals'">
                  <img [src]="images?.office_approval_icon" alt="contacts" width="14px" class="mr-2" />
                  Office Approvals
                </a>
              </li>
              <ng-container *ngIf="this.userRole == 'master admin' || this.userRole == 'operations manager' || this.user_id == this.api.getUserId()">
                <li
                  class="nav-item cursor-pointer"
                  role="presentation"
                  *ngxPermissionsOnly="['setting.commission_setup.manage', 'setting.commission_setup.view']">
                  <a
                    *ngFlag="'commission'"
                    class=""
                    id="pills-agent_commission{{ tabIndex }}-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#agent_commission{{ tabIndex }}"
                    role="tab"
                    aria-controls="agent_commission{{ tabIndex }}"
                    aria-selected="false"
                    (click)="tab_name = 'Commission'">
                    <img [src]="common_images?.conjunction_icon" alt="contacts" width="14px" class="mr-2" />
                    Commission
                  </a>
                </li>
              </ng-container>
              <!-- <ng-container *ngIf="User?.deactive == true">
                <li class="nav-item cursor-pointer" role="presentation">
                  <a class="" id="pills-reassignment-tab" data-bs-toggle="pill" data-bs-target="#reassignment"
                    role="tab" aria-controls="reassignment" aria-selected="false" (click)="
                      agentListing();
                      agentContract();
                      agentLead();
                      agentTask();
                      agentProject();
                      getStaff();
                      getInspections();
                      tab_name = 'Reassignment'
                    ">
                    <img [src]="common_images?.conjunction_icon" alt="contacts" width="14px" class="mr-2" />
                    Reassignment
                  </a>
                </li>
              </ng-container> -->
              <ng-container *ngIf="userRole?.toLowerCase() == 'master admin' || userRole?.toLowerCase() == 'operations manager'">
                <li class="nav-item cursor-pointer" role="presentation">
                  <a
                    class=""
                    id="pills-mfa{{ tabIndex }}-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#mfa{{ tabIndex }}"
                    role="tab"
                    aria-controls="mfa{{ tabIndex }}"
                    aria-selected="false"
                    (click)="getMFAEnabled(); tab_name = 'MFA'">
                    <i class="pi pi-lock f-14 mr-2"></i>
                    MFA
                  </a>
                </li>
              </ng-container>
            </ul>
          </div>
          <div>
            <div class="tab-content" id="pills-tabContent">
              <div
                id="userinfo{{ tabIndex }}"
                role="tabpanel"
                attr.aria-labelledby="pills-userinfo{{ tabIndex }}-tab"
                class="tab-pane fade {{ tab_name === 'Staff Info' && 'show active' }}">
                <h3 class="f-16 pt-4 pb-3">{{ this.User['full_name'] }}</h3>
                <form [formGroup]="UserForm">
                  <div *ngIf="error?.length > 1" class="my-3 alert alert-danger" [hidden]="!error">
                    <li *ngFor="let e of error">{{ e }}</li>
                  </div>
                  <div class="mb-3 row align-items-end position-relative">
                    <div class="desc-btn">
                      <div class="d-flex justify-content-end align-items-center">
                        <button class="_primary-btn" (click)="OpenConfirmationAccountStatus(account_status)">
                          {{ account_status == true ? 'Activate' : 'Deactivate' }}
                          <i class="ml-2 f-12 pi {{ account_status == true ? 'pi-lock-open' : 'pi pi-lock' }}"></i>
                        </button>
                      </div>
                    </div>
                    <div class="col-lg-7">
                      <div class="form-group">
                        <div class="profile-thumb position-relative pt">
                          <ng-container *ngIf="croppedImage; else no_dp">
                            <img [src]="croppedImage" class="circle-profile" />
                          </ng-container>
                          <ng-template #no_dp>
                            <p class="agent-title-home">
                              {{ UserForm.controls['first_name'].value?.charAt(0) + '' + UserForm.controls['last_name'].value?.charAt(0) }}
                            </p>
                          </ng-template>
                        </div>
                        <h3 class="f-16 mt-2">{{ tab_name ? tab_name : 'Staff Info' }}</h3>
                      </div>
                    </div>
                    <div class="col-lg-5">
                      <div class="text-right">
                        <button class="_cancel-btn mr-2" (click)="CancelForm()">Cancel</button>
                        <button type="button" class="_outline-btn" (click)="updateUser(false)">Save</button>
                        <button type="button" class="_primary-btn ml-2" (click)="updateUser(true)">Save & Close</button>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-8">
                      <div class="frame-box">
                        <div class="mb-3">
                          <p class="_fw-600 f-14">Basic Info</p>
                        </div>
                        <div class="row gap15">
                          <div class="col-sm-4">
                            <div class="form-group">
                              <label class="mb-1" for="lastname">First Name *</label>
                              <input
                                type="text"
                                class="site-input"
                                formControlName="first_name"
                                [ngClass]="{ 'is-invalid': submitted && f.first_name.errors }"
                                required />
                              <div *ngIf="submitted && f.first_name.errors" class="invalid-feedback d-block">
                                <div *ngIf="f.first_name.errors.required" class="p-error">First Name is required</div>
                              </div>
                            </div>
                          </div>
                          <div class="col-sm-4">
                            <div class="form-group">
                              <label class="mb-1" for="firstname">Last Name *</label>
                              <input
                                type="text"
                                class="site-input"
                                formControlName="last_name"
                                [ngClass]="{ 'is-invalid': submitted && f.last_name.errors }"
                                required />
                              <div *ngIf="submitted && f.last_name.errors" class="invalid-feedback d-block">
                                <div *ngIf="f.last_name.errors.required" class="p-error">Last Name is required</div>
                              </div>
                            </div>
                          </div>
                          <div class="col-sm-4">
                            <div class="form-group">
                              <label class="mb-1" for="email">Email *</label>
                              <input
                                type="text"
                                class="site-input"
                                formControlName="email"
                                [ngClass]="{ 'is-invalid': submitted && f.email.errors }"
                                required />
                              <div *ngIf="submitted && f.email.errors" class="invalid-feedback d-block">
                                <div *ngIf="f.email.errors.required" class="p-error">Email is required</div>
                                <div *ngIf="f.email.errors.strictEmail">Valid email required</div>
                              </div>
                            </div>
                          </div>
                          <div class="col-sm-4 col-xs-8">
                            <div class="mb-2 form-group">
                              <label class="mb-1 web_">Mobile Number</label>
                              <input
                                type="text"
                                inputmode="numeric"
                                autocomplete="tel-national"
                                class="site-input"
                                formControlName="mobile"
                                appMobileMask
                                placeholder="0000 000 000" />
                            </div>
                          </div>
                          <div class="col-sm-4">
                            <div class="form-group">
                              <label class="mb-1" for="telephone">Telephone</label>
                              <div class="input-group with-right-icon">
                                <input type="number" class="site-input" formControlName="telephone" />
                                <a
                                  *ngIf="UserForm.get('telephone').value && UserForm.get('telephone').value != ''"
                                  href="tel:{{ UserForm.get('telephone').value }}"
                                  ><i class="pi pi-phone cp"></i
                                ></a>
                              </div>
                            </div>
                          </div>
                          <div class="col-sm-5">
                            <div class="form-group">
                              <label class="mb-1" for="position">Job Title</label>
                              <input type="text" class="site-input" formControlName="position" />
                            </div>
                          </div>
                          <div class="col-sm-5 col-xs-8">
                            <div class="form-group">
                              <label class="mb-1" for="password">Password *</label>
                              <div class="input-group with-right-icon">
                                <input
                                  [type]="passType ? passType : 'password'"
                                  class="site-input"
                                  autocomplete="new-password"
                                  formControlName="password"
                                  value="{{ randomstring }}"
                                  [ngClass]="{ 'is-invalid': submitted && f.last_name.errors }" />
                                <img [src]="login_images?.eye_closed" alt="" class="icon_see" (click)="togglePasswordType()" />
                              </div>
                              <div *ngIf="submitted && f.password.errors" class="invalid-feedback d-block">
                                <div *ngIf="f.password.errors.required" class="p-error">Password is required</div>
                                <div *ngIf="f.password.errors.minlength" class="p-error">Password must be at least 12 characters</div>
                              </div>
                            </div>
                          </div>
                          <div class="pl-0 col-sm-2 col-xs-4 text-right password-btn">
                            <div class="form-group">
                              <label class="mb-1" for="password" class="invisible">Password</label>
                              <button class="preview-btn" (click)="generatePassword()">Generate Password</button>
                            </div>
                          </div>
                          <div
                            class="d-flex align-items-center gap-4 cursor-pointer w-auto"
                            (click)="showHideBio = !showHideBio"
                            tooltipPosition="top"
                            pTooltip="{{ showHideBio ? 'Hide' : 'Show' }} Biography">
                            <label class="mb-1 cursor-pointer" for="profilepicture">Biography</label>
                            <i class="pi {{ showHideBio ? 'pi-angle-down' : 'pi-angle-up' }}"></i>
                          </div>
                          <div class="col-sm-12" [ngClass]="{ 'd-none': !showHideBio }">
                            <div class="form-group mb-0">
                              <textarea formControlName="bio" class="site-input" cols="20" rows="5"></textarea>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="frame-box mt-3 mb-3">
                        <div class="mb-3">
                          <p class="_fw-600 f-14">User Details</p>
                        </div>
                        <div class="row">
                          <div class="col-sm-4">
                            <div class="form-group">
                              <label class="mb-1" for="group">Groups</label>
                              <re-multiSelect
                                [options]="groups"
                                formControlName="group"
                                optionLabel="name"
                                optionValue="_id"
                                placeholder="Select Groups">
                              </re-multiSelect>
                            </div>
                          </div>
                          <div class="col-sm-4">
                            <div class="form-group">
                              <label class="mb-1" for="office">Office *</label>
                              <re-multiSelect
                                [options]="offices"
                                [required_class]="submitted && f.office.errors ? 'is-invalid' : ''"
                                formControlName="office"
                                optionLabel="name"
                                optionValue="_id"
                                placeholder="Select Office"></re-multiSelect>
                              <div *ngIf="submitted && f.office.errors" class="invalid-feedback d-block">
                                <div *ngIf="f.office.errors.required" class="p-error">Office is required</div>
                              </div>
                            </div>
                          </div>
                          <div class="col-sm-4" *ngIf="userRole?.toLowerCase() == 'master admin' || userRole?.toLowerCase() == 'operations manager'">
                            <div class="form-group">
                              <label class="mb-1" for="sub_offices">Sub Offices</label>
                              <re-multiSelect
                                [options]="subOffices"
                                formControlName="sub_offices"
                                optionLabel="office_name"
                                optionValue="_id"
                                placeholder="Select Sub Offices"></re-multiSelect>
                            </div>
                          </div>
                          <div class="col-sm-4" *ngIf="userRole?.toLowerCase() == 'master admin' || userRole?.toLowerCase() == 'operations manager'">
                            <div class="form-group">
                              <label class="mb-1" for="default_sub_office_report">Default Office</label>
                              <ng-select
                                [items]="subOffices"
                                bindLabel="office_name"
                                bindValue="_id"
                                [searchable]="true"
                                [clearable]="true"
                                placeholder="Select Default Office"
                                formControlName="default_sub_office_report"></ng-select>
                            </div>
                          </div>
                          <div class="col-sm-4">
                            <div class="form-group mb-0">
                              <label class="mb-1" for="role">Role *</label>
                              <ng-select
                                formControlName="role_id"
                                [items]="roles"
                                bindLabel="name"
                                bindValue="_id"
                                [searchable]="true"
                                placeholder="Select Role"
                                [ngClass]="{ '_input-error': submitted && f.role_id.errors }">
                                <ng-template ng-option-tmp let-item="item">
                                  <div tooltipPosition="top" [pTooltip]="item.name">{{ item.name }}</div>
                                </ng-template>
                              </ng-select>
                              <div *ngIf="submitted && f.role_id.errors" class="invalid-feedback d-block">
                                <div *ngIf="f.role_id.errors.required" class="p-error">Role is required</div>
                              </div>
                            </div>
                          </div>
                          <div class="col-sm-12 mt-2" *ngIf="showAssignAgents">
                            <app-assign-agents [assistantUserId]="user_id" [officeId]="api.getOfficeId()"></app-assign-agents>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-4">
                      <div class="frame-box">
                        <div class="mb-3">
                          <p class="_fw-600 f-14">Social Settings</p>
                        </div>
                        <div class="row gap15">
                          <div class="col-sm-12">
                            <div class="form-group">
                              <label class="mb-1" for="facebookurl">Facebook URL</label>
                              <input type="text" class="site-input" formControlName="facebook" />
                              <div
                                *ngIf="UserForm.get('facebook')?.errors?.invalidSocialUrl && UserForm.get('facebook')?.touched"
                                class="text-danger mt-2">
                                {{ UserForm.get('facebook')?.errors?.invalidSocialUrl }}
                              </div>
                            </div>
                          </div>
                          <div class="col-sm-12">
                            <div class="form-group">
                              <label class="mb-1" for="twitterurl">X URL</label>
                              <input type="text" class="site-input" formControlName="twitter" />
                              <div
                                *ngIf="UserForm.get('twitter')?.errors?.invalidSocialUrl && UserForm.get('twitter')?.touched"
                                class="text-danger mt-2">
                                {{ UserForm.get('twitter')?.errors?.invalidSocialUrl }}
                              </div>
                            </div>
                          </div>
                          <div class="col-sm-12">
                            <div class="form-group">
                              <label class="mb-1" for="instagramurl">Instagram URL</label>
                              <input type="text" class="site-input" formControlName="instagram" />
                              <div
                                *ngIf="UserForm.get('instagram')?.errors?.invalidSocialUrl && UserForm.get('instagram')?.touched"
                                class="text-danger mt-2">
                                {{ UserForm.get('instagram')?.errors?.invalidSocialUrl }}
                              </div>
                            </div>
                          </div>
                          <div class="col-sm-12">
                            <div class="form-group">
                              <label class="mb-1" for="linkedInurl">LinkedIn URL</label>
                              <input type="text" class="site-input" formControlName="linkedin" />
                              <div
                                *ngIf="UserForm.get('linkedin')?.errors?.invalidSocialUrl && UserForm.get('linkedin')?.touched"
                                class="text-danger mt-2">
                                {{ UserForm.get('linkedin')?.errors?.invalidSocialUrl }}
                              </div>
                            </div>
                          </div>
                          <div class="col-sm-12">
                            <div class="form-group">
                              <label class="mb-1" for="websiteurl">Website URL</label>
                              <input type="text" class="site-input" formControlName="website" />
                              <div
                                *ngIf="UserForm.get('website')?.errors?.invalidSocialUrl && UserForm.get('website')?.touched"
                                class="text-danger mt-2">
                                {{ UserForm.get('website')?.errors?.invalidSocialUrl }}
                              </div>
                            </div>
                          </div>
                          <div class="col-sm-12">
                            <div class="form-group mb-0">
                              <label class="mb-1" for="websiteurl">Marketing Email</label>
                              <input type="text" class="site-input" formControlName="marketing_email" />
                              <div
                                *ngIf="UserForm.get('marketing_email')?.errors?.strictEmail && UserForm.get('website')?.touched"
                                class="text-danger mt-2">
                                <div>Must be a valid email address</div>
                              </div>
                            </div>
                          </div>
                          <div class="col-sm-12">
                            <div class="mt-3" *ngIf="ExtraCols && ExtraCols.length > 0">
                              <h3>Additional Fields</h3>
                              <div class="row">
                                <div class="col-sm-6 form-group" *ngFor="let col of ExtraCols; let i = index">
                                  <label class="mb-1">{{ col.label }}</label>
                                  <input [type]="col.type" [value]="col.value ? col.value : null" (change)="addValue(i, $event)" class="site-input" />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
              <div
                id="images{{ tabIndex }}"
                role="tabpanel"
                attr.aria-labelledby="pills-images{{ tabIndex }}-tab"
                class="tab-pane fade {{ tab_name === 'Images' && 'show active' }}">
                <ng-container *ngTemplateOutlet="staffNamePanel"></ng-container>
                <div class="pb-5" *ngIf="tab_name == 'Images'">
                  <app-edit-user-images [userId]="user_id" (updateUserImages)="onReceivedUpdateImages($event)"></app-edit-user-images>
                </div>
              </div>
              <div
                id="associate{{ tabIndex }}"
                role="tabpanel"
                attr.aria-labelledby="pills-associate{{ tabIndex }}-tab"
                class="tab-pane fade {{ tab_name === 'Associations' && 'show active' }}">
                <ng-container *ngTemplateOutlet="staffNamePanel"></ng-container>
                <div class="scroll_landing_page mobile_table">
                  <div class="d-flex">
                    <div class="position-relative">
                      <input
                        type="text"
                        (input)="dt4.filterGlobal($event.target.value, 'contains')"
                        class="_input-icon"
                        placeholder="Search keyword" />
                      <i class="pi pi-search _search-icon"></i>
                    </div>
                    <div class="ml-auto d-flex">
                      <img
                        [src]="common_images?.delete_icon"
                        class="mr-2 cursor-pointer"
                        width="20px"
                        (click)="deleteProjects(AssociatedProjectSelection)"
                        *ngIf="AssociatedProjectSelection?.length > 0" />
                      <re-multiSelect
                        [options]="lmService?.ProjectList"
                        [(ngModel)]="AddNewProject"
                        optionLabel="Project_Name"
                        optionValue="_id"
                        placeholder="Add project"
                        class="w300 mr-2">
                      </re-multiSelect>
                      <button *ngIf="AddNewProject" class="custom-button" (click)="AssociateUserToProject('add', AddNewProject)">
                        <i class="pi pi-plus custom-icon f-12"></i>
                        <span class="custom-text">Add</span>
                      </button>
                    </div>
                  </div>
                  <p-table
                    #dt4
                    [value]="AssociatedProjectsUsers"
                    styleClass="p-datatable-sm"
                    [globalFilterFields]="['Project_Name']"
                    [(selection)]="AssociatedProjectSelection"
                    dataKey="_id">
                    <ng-template pTemplate="header">
                      <tr>
                        <th class="tableData">
                          <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                        </th>
                        <th pSortableColumn="Project_Name" class="bg-white">
                          <div class="d-flex align-items-center">
                            Name
                            <p-sortIcon field="Project_Name" class="pl-2"></p-sortIcon>
                          </div>
                        </th>
                        <th class="associate-action">Action</th>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-project>
                      <tr class="compact-form">
                        <td class="tableData">
                          <p-tableCheckbox [value]="project"></p-tableCheckbox>
                        </td>
                        <td>{{ project.Project_Name }}</td>
                        <td class="associate-action">
                          <img [src]="common_images?.delete_icon" class="mr-2 cursor-pointer" width="15px" (click)="deleteProjects([project])" />
                        </td>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                      <tr>
                        <td colspan="3">No records found</td>
                      </tr>
                    </ng-template>
                  </p-table>
                </div>
              </div>
              <div
                id="team{{ tabIndex }}"
                role="tabpanel"
                attr.aria-labelledby="pills-team{{ tabIndex }}-tab"
                class="tab-pane fade {{ tab_name === 'Teams' && 'show active' }}">
                <ng-container *ngTemplateOutlet="staffNamePanel"></ng-container>
                <div class="scroll_landing_page position-relative scroll-section-border mobile_table" #scrollableElement>
                  <div class="d-flex">
                    <div class="position-relative">
                      <input
                        type="text"
                        (input)="dt2.filterGlobal($event.target.value, 'contains')"
                        class="_input-icon"
                        placeholder="Search keyword" />
                      <i class="pi pi-search _search-icon"></i>
                    </div>
                    <div class="ml-auto d-flex team_chip">
                      <ng-select
                        *ngIf="AssociatedTeamSelection?.length < 1"
                        [items]="Teams"
                        bindLabel="name"
                        bindValue="_id"
                        [searchable]="true"
                        [multiple]="true"
                        [(ngModel)]="addNewTeam"
                        name="team"
                        placeholder="Select Team"
                        [clearable]="false"
                        class="w300 team_w">
                        <ng-template ng-header-tmp>
                          <a href="javascript:void(0)" (click)="show()" class="link-color"> <i class="fa fa-plus"></i> Create new </a>
                        </ng-template>
                        <ng-template ng-label-tmp let-item="item">
                          <div class="d-flex align-items-center label_">
                            <i class="pi pi-times-circle pr-1" (click)="clear(item?._id, 'team')"></i>
                            <p class="ng-value-label">{{ item.name }}</p>
                          </div>
                        </ng-template>
                        <ng-template ng-option-tmp let-item="item">
                          <span tooltipPosition="top" [pTooltip]="item.name">{{ item.name }}</span>
                        </ng-template>
                      </ng-select>
                      <button
                        *ngIf="addNewTeam && AssociatedTeamSelection?.length < 1"
                        class="ml-2 custom-button margin_top"
                        [disabled]="addNewTeam?.length < 1"
                        (click)="AssociateUserToTeam('add', addNewTeam)">
                        <i class="pi pi-plus custom-icon"></i>
                        <span class="custom-text">Add</span>
                      </button>
                      <button
                        (click)="deleteTeams(AssociatedTeamSelection)"
                        *ngIf="AssociatedTeamSelection?.length > 0"
                        class="_outline-btn d-flex align-items-center">
                        <img [src]="common_images?.delete_icon" alt="delete" width="12px" class="mr-1" />Delete
                      </button>
                    </div>
                  </div>
                  <p-table
                    #dt2
                    [value]="AssociatedTeamUsers"
                    styleClass="p-datatable-sm"
                    [globalFilterFields]="['team.name']"
                    [(selection)]="AssociatedTeamSelection"
                    dataKey="_id">
                    <ng-template pTemplate="header">
                      <tr class="team-columns">
                        <th class="tableData" style="max-width: 50px">
                          <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                        </th>
                        <th>
                          <div class="d-flex align-items-center">
                            Name
                            <p-sortIcon field="team.name" pSortableColumn="team.name" class="pl-2"></p-sortIcon>
                          </div>
                        </th>
                        <th class="tableData2">Action</th>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-teams>
                      <tr class="compact-form">
                        <td class="tableData" style="max-width: 50px">
                          <p-tableCheckbox [value]="teams"></p-tableCheckbox>
                        </td>
                        <td>{{ teams?.team?.name }}</td>
                        <td class="action-icon">
                          <img
                            [src]="common_images?.edit_icon"
                            width="15px"
                            class="cursor-pointer mr-2"
                            [routerLink]="['/setting/teams/team-edit', teams?.team?._id]" />
                          <img [src]="common_images?.delete_icon" class="cursor-pointer" width="15px" alt="delete" (click)="deleteTeams([teams])" />
                        </td>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                      <tr>
                        <td colspan="3">No records found</td>
                      </tr>
                    </ng-template>
                  </p-table>
                </div>
              </div>
              <div
                id="notification{{ tabIndex }}"
                role="tabpanel"
                attr.aria-labelledby="pills-notification{{ tabIndex }}-tab"
                class="tab-pane fade {{ tab_name === 'Notification' && 'show active' }}">
                <ng-container *ngTemplateOutlet="staffNamePanel"></ng-container>
                <div class="row mt-2">
                  <div class="d-flex align-items-center mt-2">
                    <p class="w-25 mobile_w">Web Notifications</p>
                    <div>
                      <p-inputSwitch
                        [(ngModel)]="listing_approval_web_notification"
                        (onChange)="allowNotification()"
                        pTooltip="When turned off, you will not be able to view live updates"
                        tooltipPosition="right"></p-inputSwitch>
                    </div>
                  </div>
                  <div class="d-flex align-items-center mt-2">
                    <p class="w-25 mobile_w">Email Notifications</p>
                    <div>
                      <p-inputSwitch [(ngModel)]="listing_approval_email_notification" (onChange)="allowNotification()"></p-inputSwitch>
                    </div>
                  </div>
                </div>
              </div>
              <div
                id="holiday{{ tabIndex }}"
                role="tabpanel"
                attr.aria-labelledby="pills-holiday{{ tabIndex }}-tab"
                class="tab-pane fade {{ tab_name === 'Staff Holiday' && 'show active' }}">
                <ng-container *ngTemplateOutlet="staffAttachPanel"></ng-container>
              </div>
              <div
                id="officeApproval{{ tabIndex }}"
                role="tabpanel"
                attr.aria-labelledby="pills-officeApproval{{ tabIndex }}-tab"
                class="tab-pane fade {{ tab_name === 'Office Approvals' && 'show active' }}">
                <ng-container *ngTemplateOutlet="staffNamePanel"></ng-container>
                <div class="pt-1">
                  <div class="component-wrapper">
                    <div class="d-flex">
                      <div class="w-100 c-main">
                        <div class="c-main-body h-100">
                          <div class="d-flex align-items-center">
                            <p class="f-12 _fw-700">Listing Approvals</p>
                          </div>
                          <div class="text-right">
                            <button class="_outline-btn primary-color {{ permission_array?.length === 0 ? 'mb-4' : '' }}" (click)="addPermission()">
                              <i class="pi pi-plus mr-2 f-10"></i>Add
                            </button>
                          </div>
                          <div class="user-view-workarea px-0 pt-0">
                            <form class="form">
                              <div class="create-user-form">
                                <ng-container *ngFor="let item of permission_array; let ind = index">
                                  <div class="row">
                                    <div class="col-sm-3">
                                      <div class="form-group">
                                        <ng-select
                                          [items]="selectAssign"
                                          bindLabel="name"
                                          bindValue="value"
                                          [searchable]="false"
                                          [(ngModel)]="item.type"
                                          [ngModelOptions]="{ standalone: true }"
                                          placeholder="Please Select"
                                          [multiple]="false"
                                          (change)="item.included = null"
                                          class="w-76 mb-1 trigger-Name"
                                          name="all_user_receiver_type"
                                          id="all_user_receiver_type">
                                          <ng-template ng-option-tmp let-item="item">
                                            <div tooltipPosition="top" [pTooltip]="item.name">{{ item.name }}</div>
                                          </ng-template>
                                        </ng-select>
                                      </div>
                                    </div>
                                    <div class="col-sm-4">
                                      <ng-container *ngIf="item.type === 'staff'">
                                        <div class="form-group">
                                          <re-multiSelect
                                            [options]="originalAssigns"
                                            [(ngModel)]="item.included"
                                            optionLabel="full_name"
                                            optionValue="_id"
                                            placeholder="Please Select"></re-multiSelect>
                                        </div>
                                      </ng-container>
                                      <ng-container *ngIf="item.type === 'team'">
                                        <div class="form-group">
                                          <re-multiSelect
                                            [options]="Teams"
                                            [(ngModel)]="item.included"
                                            optionLabel="name"
                                            optionValue="_id"
                                            placeholder="Please Select"></re-multiSelect>
                                        </div>
                                      </ng-container>
                                      <ng-container *ngIf="item.type === 'user_role'">
                                        <div class="form-group">
                                          <re-multiSelect
                                            [options]="roles"
                                            [(ngModel)]="item.included"
                                            optionLabel="name"
                                            optionValue="_id"
                                            placeholder="Please Select"></re-multiSelect>
                                        </div>
                                      </ng-container>
                                    </div>
                                    <div class="col-sm-4">
                                      <div class="form-group">
                                        <re-multiSelect
                                          [options]="office_permission"
                                          [(ngModel)]="item.permission"
                                          optionLabel="name"
                                          optionValue="value"
                                          placeholder="Please Select"></re-multiSelect>
                                      </div>
                                    </div>
                                    <div class="col-sm-1" *ngIf="permission_array?.length > 1">
                                      <div class="form-group mt-2">
                                        <label class="mb-1" for=""></label>
                                        <i class="pi pi-times-circle cursor-pointer" (click)="removePermission(ind)"></i>
                                      </div>
                                    </div>
                                  </div>
                                </ng-container>
                                <div class="text-right">
                                  <button class="_primary-btn" type="submit" (click)="onSubmit()">Save</button>
                                </div>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                id="agent_commission{{ tabIndex }}"
                role="tabpanel"
                attr.aria-labelledby="pills-agent_commission{{ tabIndex }}-tab"
                class="tab-pane fade {{ tab_name === 'Commission' && 'show active' }}">
                <ng-container *ngTemplateOutlet="staffNamePanel"></ng-container>
                <div class="pt-1" *ngIf="tab_name == 'Commission'">
                  <app-staff-commission></app-staff-commission>
                </div>
              </div>
              <div
                id="reassignment{{ tabIndex }}"
                role="tabpanel"
                attr.aria-labelledby="pills-reassignment{{ tabIndex }}-tab"
                class="tab-pane fade {{ tab_name === 'Reassignment' && 'show active' }}">
                <ng-container *ngTemplateOutlet="staffAttachPanel"></ng-container>
              </div>
              <div
                id="mfa{{ tabIndex }}"
                role="tabpanel"
                attr.aria-labelledby="pills-mfa{{ tabIndex }}-tab"
                class="tab-pane fade {{ tab_name === 'MFA' && 'show active' }}">
                <ng-container *ngTemplateOutlet="staffAttachPanel"></ng-container>
                <ng-container *ngIf="this.Enabled_MFA; else no_mfa">
                  <div class="mfacard">
                    <div class="mx-1">
                      <div class="d-flex align-items-center justify-content-center">
                        <i class="pi pi-check mfaicon"></i>
                      </div>
                      <p class="_fw-600 f-14 text-center mt-3">MFA is enabled</p>
                      <p class="text-center mt-4">
                        {{
                          Enabled_MFA == 'email-authenticator'
                            ? 'Email'
                            : Enabled_MFA == 'microsoft-authenticator'
                              ? 'Microsoft'
                              : Enabled_MFA == 'authy-authenticator'
                                ? 'Authy'
                                : 'Google'
                        }}
                        Authenticator is enabled on your account
                      </p>
                    </div>
                  </div>
                  <div>
                    <button (click)="resetMFA()" class="_primary-btn mt-3">MFA Reset</button>
                  </div>
                </ng-container>
                <ng-template #no_mfa>
                  <div class="mfacard">
                    <div class="mx-1">
                      <div class="d-flex align-items-center justify-content-center">
                        <i class="pi pi-times nomfaicon"></i>
                      </div>
                      <p class="_fw-600 f-14 text-center mt-3">“No MFA”</p>
                    </div>
                  </div>
                </ng-template>
              </div>
            </div>
            <!-- End Tab Content -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-container *ngIf="visible">
  <div class="custom-modal">
    <div class="modal-content p-0">
      <div>
        <div class="c-col w-100 c-main pl-3">
          <div class="c-main-body">
            <div class="p-3">
              <div class="d-flex align-items-center justify-content-between border-bottom pt-1 pb-3">
                <h3 class="f-18">Add Team</h3>
              </div>
              <form [formGroup]="addTeam" class="form" (ngSubmit)="createTeam()">
                <div class="row">
                  <div class="col-md-5">
                    <div class="form-group my-4">
                      <div class="profile-section d-flex align-items-center">
                        <div class="profile-thumb position-relative">
                          <img [src]="teamUrl ? teamUrl : common_images?.user_profile_icon" class="circle-profile" />
                          <label for="teamInput" class="edit-file cp">
                            <img [src]="common_images?.edit_icon" alt="" class="profile-changer" />
                            <input
                              id="teamInput"
                              class="d-none"
                              type="file"
                              name="teamProfile"
                              (change)="onTeamSelectFile($event)"
                              accept=".jpg, .jpeg, .png" />
                          </label>
                          <img
                            class="cursor-pointer ml-2 mb-5 profile-changer"
                            [src]="common_images?.delete_icon"
                            width="14px"
                            (click)="delProfileImage($event)"
                            *ngIf="teamUrl" />
                        </div>
                        <div class="profile-content pl-3">
                          <p>Upload profile picture</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label for="officenm">Team Name *</label>
                      <input
                        type="text"
                        class="site-input"
                        formControlName="name"
                        class="mb-1"
                        [ngClass]="{ invalidField: addTeam.controls['name'].hasError('required') && addTeam.controls['name'].touched }" />
                      <div *ngIf="addTeam.controls['name'].touched" class="invalid-form">
                        <div *ngIf="addTeam.controls['name'].hasError('required')">Team Name is required</div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="officenam">Office *</label>
                      <ng-select
                        formControlName="office_id"
                        [items]="offices"
                        bindLabel="name"
                        bindValue="_id"
                        [searchable]="true"
                        placeholder="Select Office"
                        (change)="loadUsers()"
                        class="mb-1"
                        [ngClass]="{ '_input-error': addTeam.controls['office_id'].hasError('required') && addTeam.controls['office_id'].touched }">
                        <ng-template ng-option-tmp let-item="item">
                          <span tooltipPosition="top" [pTooltip]="item.name">{{ item.name }}</span>
                        </ng-template>
                      </ng-select>
                      <div *ngIf="addTeam.controls['office_id'].touched" class="invalid-form">
                        <div *ngIf="addTeam.controls['office_id'].hasError('required')">Office is required</div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <label for="officename">Team Member *</label>
                      <div>
                        <re-multiSelect
                          [options]="users"
                          [required_class]="
                            addTeam.controls['members'].hasError('required') && addTeam.controls['members'].touched ? 'is-invalid' : ''
                          "
                          formControlName="members"
                          optionLabel="full_name"
                          optionValue="_id"
                          placeholder="Select Members"></re-multiSelect>
                      </div>
                      <div *ngIf="addTeam.controls['members'].touched" class="invalid-form">
                        <div *ngIf="addTeam.controls['members'].hasError('required')">Team Member(s) is required</div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12" [hidden]="addTeam.controls['members'].hasError('required')">
                    <div class="form-group">
                      <label for="officename">Team Leader *</label>
                      <ng-select
                        formControlName="leader"
                        [items]="users"
                        bindLabel="full_name"
                        bindValue="_id"
                        [searchable]="true"
                        placeholder="Select Leader  "
                        [ngClass]="{ '_input-error': addTeam.controls['leader'].hasError('required') && addTeam.controls['leader'].touched }">
                        <ng-template ng-option-tmp let-item="item">
                          <span tooltipPosition="top" [pTooltip]="item.full_name">{{ item.full_name }}</span>
                        </ng-template>
                      </ng-select>
                      <div *ngIf="addTeam.controls['leader'].touched" class="invalid-form">
                        <div *ngIf="addTeam.controls['leader'].hasError('required')">Team Leader is required</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group mt-3 text-right">
                  <button class="_cancel-btn mr-3" (click)="close()">Cancel</button>
                  <button type="submit" class="_outline-btn" [class.disabled]="isLoading">
                    <span> Create Team</span>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <button (click)="close()" class="popup-close"><i class="pi pi-times f-14"></i></button>
    </div>
  </div>
</ng-container>

<ng-template #staffAttachPanel>
  <ng-container *ngTemplateOutlet="staffNamePanel"></ng-container>
  <ng-container *ngIf="tab_name == 'Staff Holiday'; else noHoliday">
    <div class="row mt-3">
      <div class="col-sm-2">
        <div class="form-group">
          <label class="f-12 _fw-600">Type</label>
          <ng-select
            [items]="absenceTypes"
            bindLabel="label"
            bindValue="value"
            [clearable]="false"
            appendTo="body"
            [(ngModel)]="absenceType"
            [ngModelOptions]="{ standalone: true }"></ng-select>
        </div>
      </div>
      <div class="col-sm-3">
        <div class="form-group">
          <label class="f-12 _fw-600">Dates</label>
          <div class="date-border w-100">
            <p-calendar
              [(ngModel)]="holiday_date"
              [ngModelOptions]="{ standalone: true }"
              placeholder="DD/MM/YYYY"
              icon="pi pi-calendar-minus"
              dateFormat="dd/mm/yy"
              appendTo="body"
              [firstDayOfWeek]="1"
              [showButtonBar]="true"
              [showIcon]="true"
              [readonlyInput]="true"
              [maxDateCount]="2"
              selectionMode="range">
            </p-calendar>
          </div>
        </div>
      </div>
      <div class="col-sm-3">
        <div class="form-group">
          <label class="f-12 _fw-600">Cover (optional)</label>
          <ng-select
            [items]="OfficeStaff"
            bindLabel="full_name"
            bindValue="_id"
            placeholder="Leave blank to use the normal rotation"
            appendTo="body"
            [(ngModel)]="absenceCoverUserId"
            [ngModelOptions]="{ standalone: true }"></ng-select>
        </div>
      </div>
      <div class="col-sm-3">
        <div class="form-group">
          <label class="f-12 _fw-600">Note (optional)</label>
          <input type="text" [(ngModel)]="absenceNote" [ngModelOptions]="{ standalone: true }" placeholder="e.g. Annual leave" />
        </div>
      </div>
      <div class="col-sm-1 d-flex align-items-end">
        <div class="form-group w-100">
          <button class="_primary-btn w-100" [class.disabled]="isAbsenceSaving" (click)="addHoliday()">
            {{ isAbsenceSaving ? 'Saving...' : 'Save' }}
          </button>
        </div>
      </div>
    </div>

    <div class="staff-absence">
      <div class="staff-absence__row staff-absence__row--head">
        <span>Type</span>
        <span>Dates</span>
        <span>Cover</span>
        <span>Note</span>
        <span></span>
      </div>
      <div class="staff-absence__row" *ngFor="let absence of absences">
        <span class="staff-absence__type" [class.is-sick]="absence.type === 'sick'">{{ absenceTypeLabel(absence.type) }}</span>
        <span>{{ absence.from | date: 'dd/MM/yyyy' }} – {{ absence.to | date: 'dd/MM/yyyy' }}</span>
        <span>{{ coverName(absence) }}</span>
        <span>{{ absence.note || '—' }}</span>
        <span class="text-right">
          <button type="button" class="icon_btn" pTooltip="Remove" (click)="removeAbsence(absence)"><i class="pi pi-trash"></i></button>
        </span>
      </div>
      <div class="staff-absence__empty" *ngIf="!absences.length">No holiday or sickness recorded for this staff member.</div>
    </div>

    <div class="staff-absence__note">
      <i class="pi pi-info-circle mr-2"></i>
      While an absence is running this user is skipped by lead assignment. Their share goes to the nominated cover, or back to the normal rotation
      when none is set. The office's Operations Managers are notified whenever one is added.
    </div>
  </ng-container>
  <ng-template #noHoliday> </ng-template>
  <!-- <div class="mt-3 d-flex align-item-center flex-wrap gap-3">
    <ng-container *ngFor="let row of rows; let i = index">
      <div class="compare-box">
        <ng-container *ngIf="row.selected_module == 'contract'">
          <div class="d-flex justify-content-between">
            <p class="f-14 _fw-600">Contract</p>
            <div class="text-right">
              <button class="_primary-btn" (click)="assignedOtherAgent()">Save</button>
            </div>
          </div>
          <div class="my-2 d-flex align-items-center justify-content-between">
            <p class="f-14 _fw-600">All</p>
            <div *ngIf="row.isAgent">
              <ng-select
                [items]="TempOfficeStaff"
                bindLabel="full_name"
                bindValue="full_name"
                [searchable]="true"
                placeholder="Select Agent"
                class="w-250"
                appendTo="body"
                (change)="assignStaff($event, 'full_name', i)">
                <ng-template ng-option-tmp let-item="item">
                  <div class="ui-helper-clearfix" tooltipPosition="top" [pTooltip]="item.full_name">
                    <p>{{ item?.full_name }}</p>
                    <p>
                      <small>{{ item?.email }}</small>
                    </p>
                  </div>
                </ng-template>
              </ng-select>
            </div>
          </div>
          <p-table id="apartmentscolumns" [value]="row?.data">
            <ng-template pTemplate="header" let-columns>
              <tr>
                <th class="w20">
                  <div>
                    <p-checkbox [(ngModel)]="row.isChecked" (onChange)="allColumn($event, i)" binary="true"></p-checkbox>
                  </div>
                </th>
                <th class="w300">Listing / Project</th>
                <th class="w200">Status</th>
                <th class="w200">Update Date</th>
                <th class="w200">Created Date</th>
                <th class="w150">Reassigment Staff</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowData let-columns="columns">
              <tr>
                <td class="pl-3">
                  <div>
                    <p-checkbox (onChange)="selectColumn(i)" [(ngModel)]="rowData.isChecked" binary="true"></p-checkbox>
                  </div>
                </td>
                <td class="tableData3" class="pl-3">
                  {{ rowData.property_address }}
                </td>
                <td class="tableData3" class="pl-3">
                  {{ rowData.status }}
                </td>
                <td class="tableData3" class="pl-3">
                  {{ rowData.updated_at | date: 'dd/MM/yy' }}
                </td>
                <td class="tableData3" class="pl-3">
                  {{ rowData.created_at | date: 'dd/MM/yy' }}
                </td>
                <td class="tableData3" class="pl-3">
                  <ng-select
                    [(ngModel)]="rowData.agent_id"
                    [items]="TempOfficeStaff"
                    bindLabel="full_name"
                    bindValue="full_name"
                    [searchable]="true"
                    placeholder="Select Agent"
                    class="w-250"
                    appendTo="body">
                    <ng-template ng-option-tmp let-item="item">
                      <div class="ui-helper-clearfix" tooltipPosition="top" [pTooltip]="item.full_name">
                        <p>{{ item?.full_name }}</p>
                        <p>
                          <small>{{ item?.email }}</small>
                        </p>
                      </div>
                    </ng-template>
                  </ng-select>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="5">{{ 'No record available' }}</td>
              </tr>
            </ng-template>
          </p-table>
        </ng-container>
        <ng-container *ngIf="row.selected_module == 'properties'">
          <div class="d-flex justify-content-between">
            <p class="f-14 _fw-600">Listing</p>
            <div class="text-right">
              <button class="_primary-btn" (click)="assignedOtherAgent()">Save</button>
            </div>
          </div>
          <div class="my-2 d-flex align-items-center justify-content-between">
            <p class="f-14 _fw-600">All</p>
            <div *ngIf="row.isAgent">
              <ng-select
                [items]="TempOfficeStaff"
                bindLabel="full_name"
                bindValue="_id"
                [searchable]="true"
                placeholder="Select Agent"
                class="w-250"
                appendTo="body"
                (change)="assignStaff($event, '_id', i)">
                <ng-template ng-option-tmp let-item="item">
                  <div class="ui-helper-clearfix" tooltipPosition="top" [pTooltip]="item.full_name">
                    <p>{{ item?.full_name }}</p>
                    <p>
                      <small>{{ item?.email }}</small>
                    </p>
                  </div>
                </ng-template>
              </ng-select>
            </div>
          </div>
          <p-table id="apartmentscolumns" [value]="row?.data">
            <ng-template pTemplate="header" let-columns>
              <tr>
                <th class="w20">
                  <div>
                    <p-checkbox [(ngModel)]="row.isChecked" (onChange)="allColumn($event, i)" binary="true"></p-checkbox>
                  </div>
                </th>
                <th class="w300">Listing</th>
                <th class="w200">Status</th>
                <th class="w200">Update Date</th>
                <th class="w200">Created Date</th>
                <th class="w150">Reassigment Staff</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowData let-columns="columns">
              <tr>
                <td class="pl-3">
                  <div>
                    <p-checkbox (onChange)="selectColumn(i)" [(ngModel)]="rowData.isChecked" binary="true"></p-checkbox>
                  </div>
                </td>
                <td class="tableData3" class="pl-3">
                  {{ rowData.property_address }}
                </td>
                <td class="tableData3" class="pl-3">
                  {{ rowData.status }}
                </td>
                <td class="tableData3" class="pl-3">
                  {{ rowData.updated_at | date: 'dd/MM/yy' }}
                </td>
                <td class="tableData3" class="pl-3">
                  {{ rowData.created_at | date: 'dd/MM/yy' }}
                </td>
                <td class="tableData3" class="pl-3">
                  <ng-select
                    [(ngModel)]="rowData.agent_id"
                    [items]="TempOfficeStaff"
                    bindLabel="full_name"
                    bindValue="_id"
                    [searchable]="true"
                    placeholder="Select Agent"
                    class="w-250"
                    appendTo="body">
                    <ng-template ng-option-tmp let-item="item">
                      <div class="ui-helper-clearfix" tooltipPosition="top" [pTooltip]="item.full_name">
                        <p>{{ item?.full_name }}</p>
                        <p>
                          <small>{{ item?.email }}</small>
                        </p>
                      </div>
                    </ng-template>
                  </ng-select>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="5">{{ 'No record available' }}</td>
              </tr>
            </ng-template>
          </p-table>
        </ng-container>
        <ng-container *ngIf="row.selected_module == 'ofi'">
          <div class="d-flex justify-content-between">
            <p class="f-14 _fw-600">OFIs</p>
            <div class="text-right">
              <button class="_primary-btn" (click)="assignedOtherAgent()">Save</button>
            </div>
          </div>
          <p-table id="apartmentscolumns" [value]="row?.data">
            <ng-template pTemplate="header" let-columns>
              <tr>
                <th class="w300">Listing</th>
                <th class="w200">Date</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowData let-columns="columns" let-i="rowIndex" let-expanded="expanded">
              <tr>
                <td class="tableData3" class="pl-3">
                  {{ rowData.property_address }}
                </td>
                <td class="tableData3" class="pl-3">
                  {{ rowData.date | date: 'dd/MM/yy' }}
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="2">{{ 'No record available' }}</td>
              </tr>
            </ng-template>
          </p-table>
        </ng-container>
        <ng-container *ngIf="row.selected_module == 'lead_management'">
          <div class="d-flex justify-content-between">
            <p class="f-14 _fw-600">Lead</p>
            <div class="text-right">
              <button class="_primary-btn" (click)="assignedOtherAgent()">Save</button>
            </div>
          </div>
          <div class="my-2 d-flex align-items-center justify-content-between">
            <p class="f-14 _fw-600">All</p>
            <div *ngIf="row.isAgent">
              <ng-select
                [items]="TempOfficeStaff"
                bindLabel="full_name"
                bindValue="_id"
                [searchable]="true"
                placeholder="Select Agent"
                class="w-250"
                appendTo="body"
                (change)="assignStaff($event, '_id', i)">
                <ng-template ng-option-tmp let-item="item">
                  <div class="ui-helper-clearfix" tooltipPosition="top" [pTooltip]="item.full_name">
                    <p>{{ item?.full_name }}</p>
                    <p>
                      <small>{{ item?.email }}</small>
                    </p>
                  </div>
                </ng-template>
              </ng-select>
            </div>
          </div>
          <p-table id="apartmentscolumns" [value]="row?.data">
            <ng-template pTemplate="header" let-columns>
              <tr>
                <th class="w20">
                  <div>
                    <p-checkbox [(ngModel)]="row.isChecked" (onChange)="allColumn($event, i)" binary="true"></p-checkbox>
                  </div>
                </th>
                <th class="w150">Name</th>
                <th class="w300">Listing / Project</th>
                <th class="w200">Status</th>
                <th class="w200">Update Date</th>
                <th class="w200">Created Date</th>
                <th class="w150">Reassigment Staff</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowData let-columns="columns">
              <tr>
                <td class="pl-3">
                  <div>
                    <p-checkbox (onChange)="selectColumn(i)" [(ngModel)]="rowData.isChecked" binary="true"></p-checkbox>
                  </div>
                </td>
                <td class="tableData3" class="pl-3">
                  {{ rowData.full_name }}
                </td>
                <td class="tableData3" class="pl-3">
                  {{ rowData.property_address }}
                </td>
                <td class="tableData3" class="pl-3">
                  {{ rowData.status }}
                </td>
                <td class="tableData3" class="pl-3">
                  {{ rowData.updated_at | date: 'dd/MM/yy' }}
                </td>
                <td class="tableData3" class="pl-3">
                  {{ rowData.created_at | date: 'dd/MM/yy' }}
                </td>
                <td class="tableData3" class="pl-3">
                  <ng-select
                    [(ngModel)]="rowData.agent_id"
                    [items]="TempOfficeStaff"
                    bindLabel="full_name"
                    bindValue="_id"
                    [searchable]="true"
                    placeholder="Select Agent"
                    class="w-250"
                    appendTo="body">
                    <ng-template ng-option-tmp let-item="item">
                      <div class="ui-helper-clearfix" tooltipPosition="top" [pTooltip]="item.full_name">
                        <p>{{ item?.full_name }}</p>
                        <p>
                          <small>{{ item?.email }}</small>
                        </p>
                      </div>
                    </ng-template>
                  </ng-select>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="5">{{ 'No record available' }}</td>
              </tr>
            </ng-template>
          </p-table>
        </ng-container>
        <ng-container *ngIf="row.selected_module == 'tasks'">
          <div class="d-flex justify-content-between">
            <p class="f-14 _fw-600">Task</p>
            <div class="text-right">
              <button class="_primary-btn" (click)="assignedOtherAgent()">Save</button>
            </div>
          </div>
          <div class="my-2 d-flex align-items-center justify-content-between">
            <p class="f-14 _fw-600">All</p>
            <div *ngIf="row.isAgent">
              <ng-select
                [items]="TempOfficeStaff"
                bindLabel="full_name"
                bindValue="_id"
                [searchable]="true"
                placeholder="Select Agent"
                class="w-250"
                appendTo="body"
                (change)="assignStaff($event, '_id', i)">
                <ng-template ng-option-tmp let-item="item">
                  <div class="ui-helper-clearfix" tooltipPosition="top" [pTooltip]="item.full_name">
                    <p>{{ item?.full_name }}</p>
                    <p>
                      <small>{{ item?.email }}</small>
                    </p>
                  </div>
                </ng-template>
              </ng-select>
            </div>
          </div>
          <p-table id="apartmentscolumns" [value]="row?.data">
            <ng-template pTemplate="header" let-columns>
              <tr>
                <th class="w20">
                  <div>
                    <p-checkbox [(ngModel)]="row.isChecked" (onChange)="allColumn($event, i)" binary="true"></p-checkbox>
                  </div>
                </th>
                <th class="w300">Title</th>
                <th class="w200">Status</th>
                <th class="w200">Update Date</th>
                <th class="w200">Created Date</th>
                <th class="w150">Reassigment Staff</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowData let-columns="columns">
              <tr>
                <td class="pl-3">
                  <div>
                    <p-checkbox (onChange)="selectColumn(i)" [(ngModel)]="rowData.isChecked" binary="true"></p-checkbox>
                  </div>
                </td>
                <td class="tableData3" class="pl-3">
                  {{ rowData.title }}
                </td>
                <td class="tableData3" class="pl-3">
                  {{ rowData.status }}
                </td>
                <td class="tableData3" class="pl-3">
                  {{ rowData.updated_at | date: 'dd/MM/yy' }}
                </td>
                <td class="tableData3" class="pl-3">
                  {{ rowData.created_at | date: 'dd/MM/yy' }}
                </td>
                <td class="tableData3" class="pl-3">
                  <ng-select
                    [(ngModel)]="rowData.agent_id"
                    [items]="TempOfficeStaff"
                    bindLabel="full_name"
                    bindValue="_id"
                    [searchable]="true"
                    placeholder="Select Agent"
                    class="w-250"
                    appendTo="body">
                    <ng-template ng-option-tmp let-item="item">
                      <div class="ui-helper-clearfix" tooltipPosition="top" [pTooltip]="item.full_name">
                        <p>{{ item?.full_name }}</p>
                        <p>
                          <small>{{ item?.email }}</small>
                        </p>
                      </div>
                    </ng-template>
                  </ng-select>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="5">{{ 'No record available' }}</td>
              </tr>
            </ng-template>
          </p-table>
        </ng-container>
        <ng-container *ngIf="row.selected_module == 'projects'">
          <div class="d-flex justify-content-between">
            <p class="f-14 _fw-600">Project</p>
            <div class="text-right">
              <button class="_primary-btn" (click)="assignedOtherAgent()">Save</button>
            </div>
          </div>
          <div class="my-2 d-flex align-items-center justify-content-between">
            <p class="f-14 _fw-600">All</p>
            <div *ngIf="row.isAgent">
              <ng-select
                [items]="TempOfficeStaff"
                bindLabel="full_name"
                bindValue="_id"
                [searchable]="true"
                placeholder="Select Agent"
                class="w-250"
                appendTo="body"
                (change)="assignStaff($event, '_id', i)">
                <ng-template ng-option-tmp let-item="item">
                  <div class="ui-helper-clearfix" tooltipPosition="top" [pTooltip]="item.full_name">
                    <p>{{ item?.full_name }}</p>
                    <p>
                      <small>{{ item?.email }}</small>
                    </p>
                  </div>
                </ng-template>
              </ng-select>
            </div>
          </div>
          <p-table id="apartmentscolumns" [value]="row?.data">
            <ng-template pTemplate="header" let-columns>
              <tr>
                <th class="w20">
                  <div>
                    <p-checkbox [(ngModel)]="row.isChecked" (onChange)="allColumn($event, i)" binary="true"></p-checkbox>
                  </div>
                </th>
                <th class="w200">Project</th>
                <th class="w200">Status</th>
                <th class="w200">Update Date</th>
                <th class="w200">Created Date</th>
                <th class="w150">Reassigment Staff</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowData let-columns="columns">
              <tr>
                <td class="pl-3">
                  <div>
                    <p-checkbox (onChange)="selectColumn(i)" [(ngModel)]="rowData.isChecked" binary="true"></p-checkbox>
                  </div>
                </td>
                <td class="tableData3" class="pl-3">
                  {{ rowData.project_name }}
                </td>
                <td class="tableData3" class="pl-3">
                  {{ rowData.status }}
                </td>
                <td class="tableData3" class="pl-3">
                  {{ rowData.updated_at | date: 'dd/MM/yy' }}
                </td>
                <td class="tableData3" class="pl-3">
                  {{ rowData.created_at | date: 'dd/MM/yy' }}
                </td>
                <td class="tableData3" class="pl-3">
                  <ng-select
                    [(ngModel)]="rowData.agent_id"
                    [items]="TempOfficeStaff"
                    bindLabel="full_name"
                    bindValue="_id"
                    [searchable]="true"
                    placeholder="Select Agent"
                    class="w-250"
                    appendTo="body">
                    <ng-template ng-option-tmp let-item="item">
                      <div class="ui-helper-clearfix" tooltipPosition="top" [pTooltip]="item.full_name">
                        <p>{{ item?.full_name }}</p>
                        <p>
                          <small>{{ item?.email }}</small>
                        </p>
                      </div>
                    </ng-template>
                  </ng-select>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="5">{{ 'No record available' }}</td>
              </tr>
            </ng-template>
          </p-table>
        </ng-container>
      </div>
    </ng-container>
  </div> -->
</ng-template>
<ng-template #staffNamePanel>
  <h3 class="f-16 pt-4 pb-3">{{ this.User['full_name'] }}</h3>
  <div class="mt-3 row align-items-end position-relative">
    <div class="desc-btn">
      <div class="d-flex justify-content-end align-items-center">
        <button class="_primary-btn" (click)="OpenConfirmationAccountStatus(account_status)">
          {{ account_status == true ? 'Activate' : 'Deactivate' }}
          <i class="ml-2 f-12 pi {{ account_status == true ? 'pi-lock-open' : 'pi pi-lock' }}"></i>
        </button>
      </div>
    </div>
    <div class="col-lg-7">
      <div class="form-group">
        <div class="profile-thumb position-relative mxw90">
          <ng-container *ngIf="croppedImage; else no_dp">
            <img [src]="croppedImage" class="circle-profile" />
          </ng-container>
          <ng-template #no_dp>
            <p class="agent-title-home">
              {{ UserForm.controls['first_name'].value?.charAt(0) + '' + UserForm.controls['last_name'].value?.charAt(0) }}
            </p>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
  <h3 class="f-16 my-3">{{ tab_name }}</h3>
</ng-template>
